/*
Google Map
*/

class GoogleMap extends HTMLElement {
  connectedCallback() {
    this.markerRefs = [];
    this.markerSrc = this.dataset.markerSrc;
    this.selectedMarkerSrc = this.dataset.selectedMarkerSrc;
    this.initMap();
  }

  async initMap() {
    const { Map } = await google.maps.importLibrary("maps");
    const LACoordinates = { lat: 34.052235, lng: -118.243683 };

    this.map = new Map(this.querySelector("#map"), {
      zoom: 12,
      center: LACoordinates,
      disableDefaultUI: true,
      mapId: "1c34d28cec20f046",
      backgroundColor: "#121212",
    });
  }

  moveToLocation(lat, lng) {
    this.map.panTo({ lat, lng });
  }

  moveToMarkers() {
    if (this.markerRefs.length) {
      const bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.markerRefs.length; i++) {
        bounds.extend(
          new google.maps.LatLng(this.markerRefs[i].lat, this.markerRefs[i].lng)
        );
      }
      this.map.fitBounds(bounds);

      // only do it if in desktop
      if (window.innerWidth > 768) {
        google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
          const center = this.map.getCenter();
          const scale = Math.pow(2, this.map.getZoom());
          const ZOOM_FACTOR = 1.2;
          const mapDiv = this.map.getDiv();
          const mapWidth = mapDiv.offsetWidth;

          const pixelOffset = {
            x: -(20 / 100) * mapWidth,
          };

          const worldCoordinateCenter = this.map
            .getProjection()
            .fromLatLngToPoint(center);

          // offset 20% to the left so points are always centralized
          const newCenter = this.map
            .getProjection()
            .fromPointToLatLng(
              new google.maps.Point(
                worldCoordinateCenter.x + pixelOffset.x / scale,
                worldCoordinateCenter.y
              )
            );

          // const currentZoom = this.map.getZoom();
          // this.map.setZoom(currentZoom - ZOOM_FACTOR);

          this.currentLat = newCenter.lat();
          this.currentLng = newCenter.lng();
          this.map.setCenter(newCenter);
          if (
            this.currentLat !== newCenter.lat() ||
            this.currentLng !== newCenter.lng()
          ) {
          }
        });
      }
    }
  }

  moveToMarker(markerRef) {
    if (markerRef.lat && markerRef.lng) {
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(new google.maps.LatLng(markerRef.lat, markerRef.lng));
      this.map.fitBounds(bounds, { duration: 3000, padding: 100 });
    }
  }

  addMarker(lat, lng, callback) {
    const marker = new google.maps.Marker({
      icon: {
        url: this.markerSrc,
        scaledSize: new google.maps.Size(28, 28),
      },
      position: { lat, lng },
      map: this.map,
    });

    marker.setMap(this.map);

    marker.addListener("mouseover", () => {
      marker.setIcon({
        url: this.selectedMarkerSrc,
        scaledSize: new google.maps.Size(28, 28),
      });
    });

    marker.addListener("mouseout", () => {
      if (!marker.isSelected) {
        marker.setIcon({
          url: this.markerSrc,
          scaledSize: new google.maps.Size(28, 28),
        });
      }
    });

    marker.addListener("click", () => {
      this.markerRefs.forEach(({ marker: otherMarker }) => {
        otherMarker.isSelected = false;
        otherMarker.setIcon({
          url: this.markerSrc,
          scaledSize: new google.maps.Size(28, 28),
        });
      });

      marker.isSelected = true;
      marker.setIcon({
        url: this.selectedMarkerSrc,
        scaledSize: new google.maps.Size(28, 28),
      });

      if (callback) {
        callback();
      }
    });

    const markerRef = { marker, lat, lng };
    this.markerRefs.push(markerRef);

    return markerRef;
  }

  clearMarkers() {
    this.markerRefs.forEach((markerRef) => {
      markerRef.marker.setMap(null);
    });

    this.markerRefs = [];
  }
}

customElements.define("google-map", GoogleMap);

/*
Store Locator
*/

class StoreLocator extends HTMLElement {
  connectedCallback() {
    this.formEl = this.querySelector("form");
    this.resultsEl = this.querySelector(".results");
    this.googleMap = document.querySelector("google-map");

    this.formEl.addEventListener("submit", async (e) => {
      e.preventDefault();
      e.stopPropagation();
      await this.fetchResults();
    });

    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const zipParam = urlParams.get("zip");
        const milesParam = urlParams.get("miles");
        if (zipParam && milesParam) {
          this.fetchResults(zipParam, milesParam);
        }
      }, 1000);
    });
  }

  capitalizeFirstLetters(str) {
    const words = str.toLowerCase().split(" ");

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }

    return words.join(" ");
  }

  getMiles() {
    return this.querySelector('[name="miles"]').value;
  }

  async fetchResults(zipParam = null, milesParam = null) {
    const url = `http://hunni-serverless.vercel.app/api/gin-and-juice/store-locator`;

    const zipInput = this.querySelector('[name="zip"]');
    const milesSelect = this.querySelector('[name="miles"]');
    const display = this.querySelector(".selected-display");
    const container =
      this.closest("select-input") || this.querySelector(".select-input");

    let zip = zipInput.value;
    let miles = milesSelect.value;

    if (zipParam) {
      zip = zipParam;
      zipInput.value = zipParam;
    }

    if (milesParam) {
      miles = milesParam;
      milesSelect.value = milesParam;

      const selectedOption = Array.from(milesSelect.options).find(
        (option) => option.value === milesParam && option.value !== ""
      );

      if (selectedOption) {
        display.textContent = selectedOption.text;
        container.classList.add("active");
      } else {
        display.textContent = "";
        container.classList.remove("active");
      }
    }

    const params = { zip, miles };

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("zip", zip);
    urlParams.set("miles", miles);
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    history.replaceState({}, "", newUrl);

    await fetch(url, {
      method: "POST",
      body: JSON.stringify(params),
    })
      .then((resp) => {
        if (!resp.ok) {
          throw new Error(
            "There was a problem submitting the form. Please try again."
          );
        } else {
        }
        return resp.json();
      })
      .then((resp) => {
        const { location: locations } = resp;
        this.locations = locations;
        this.setMarkers(locations);
      })
      .catch((error) => {
        console.log(error.message);
      });

    this.onComplete();
  }

  setMarkers(locations) {
    if (!locations) {
      return;
    }

    const selectedFilters =
      document.querySelector("store-filter").selectedOptions;
    const filteredLocations = locations.filter((location) => {
      return selectedFilters.some((selectedFilter) => {
        return location.otherBrand.includes(selectedFilter);
      });
    });

    this.googleMap.clearMarkers();
    this.resultsEl.innerHTML = "";

    this.googleMap.moveToMarker({
      lat: +locations[0].lat,
      lng: +locations[0].long,
    });

    filteredLocations.forEach((location) => {
      const resultItem = document.createElement("li");

      const markerRef = this.googleMap.addMarker(
        +location.lat,
        +location.long,
        () => {
          const allResultItems = document.querySelectorAll("li");
          allResultItems.forEach((item) =>
            item.classList.remove("selected-mark-map")
          );
          resultItem.classList.add("selected-mark-map");

          resultItem.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
          });
        }
      );

      resultItem.classList.add("result-item");

      resultItem.innerHTML = `
        <span>${location.distance} mi</span>
        <div>
          <h3>${this.capitalizeFirstLetters(location.dba)}</h3>
          <p>${this.capitalizeFirstLetters(location.street)}, ${
        location.state
      } ${location.zip}</p>
          <button type="button" class="button--white">Get Directions</button>
        </div>
      `;

      const getDirectionsButton = resultItem.querySelector("button");
      getDirectionsButton.addEventListener("click", () => {
        google.maps.event.trigger(markerRef.marker, "click");
        this.googleMap.moveToMarker({
          lat: +location.lat,
          lng: +location.long,
        });
      });

      resultItem.addEventListener("click", () => {
        google.maps.event.trigger(markerRef.marker, "click");
      });

      this.resultsEl.appendChild(resultItem);
    });

    this.googleMap.moveToMarkers();
  }

  renderCount(count) {
    const $h2 = this.querySelector("h2");
    $h2.textContent = `${count} ${
      count === 1 ? "Location" : "Locations"
    } Near You`;
  }

  renderResults(results) {
    const $items = document.createElement("div");
    $items.className =
      "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 lg:gap-12 mt-12 lg:mt-20";

    results.forEach((result) => {
      const $item = document.createElement("div");
      $item.className = "grid content-start !leading-tight";

      const $miles = document.createElement("span");
      $miles.className =
        "font-heading text-lg md:text-xl !leading-tight opacity-50";
      $miles.textContent = `${result.distance} mi.`;

      const $title = document.createElement("h3");
      $title.className = "font-heading text-lg md:text-xl !leading-tight mb-2";
      $title.textContent = result.dba.replace("&amp;", "&");

      const $address = document.createElement("div");
      $address.className = "grid justify-items-start";
      $address.innerHTML = `${result.street}<br />${result.city}, ${result.state} ${result.zip}<br /><a href="tel:+1${result.phone}" class="no-underline text-white">${result.phoneFormatted}</a>`;

      $item.appendChild($miles);
      $item.appendChild($title);
      $item.appendChild($address);

      $items.appendChild($item);
    });

    this.$results.appendChild($items);
  }

  showError() {
    this.$error.classList.remove("hidden");
  }

  hideError() {
    this.$error.classList.add("hidden");
  }

  resetForm() {
    this.handleLoading();
    this.emptyResults();
    this.hideError();
    this.hideMap();
  }

  onComplete() {}
}

customElements.define("store-locator", StoreLocator);

class StoreFilter extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button");
    this.dropdown = this.querySelector(".dropdown-menu");
    this.arrow = this.querySelector(".arrow-js");
    this.optionCheckboxes = Array.from(
      this.querySelectorAll('input[type="checkbox"]')
    );
    this.labelTarget = this.querySelector(".label-target-js");

    this.syncSelectedOptions();

    this.optionCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        this.syncSelectedOptions();
      });
    });

    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (this.button.getAttribute("aria-expanded") === "true") {
        this.button.setAttribute("aria-expanded", "false");
        this.dropdown.setAttribute("aria-hidden", "true");
        this.dropdown.classList.add("opacity-0");
        this.dropdown.classList.add("invisible");
        this.arrow.classList.add("!rotate-0");
        return;
      }

      this.button.setAttribute("aria-expanded", "true");
      this.dropdown.setAttribute("aria-hidden", "false");
      this.dropdown.classList.remove("invisible");
      this.dropdown.classList.remove("opacity-0");

      this.arrow.classList.remove("!rotate-0");
      this.dropdown.children[0].focus();

      document.addEventListener("click", (e) => {
        if (!this.contains(e.target)) {
          this.button.setAttribute("aria-expanded", "false");
          this.dropdown.setAttribute("aria-hidden", "true");
          this.dropdown.classList.add("opacity-0");
          this.dropdown.classList.add("invisible");
          this.arrow.classList.add("!rotate-0");
        }
      });

      return;
    });

    this.button.setAttribute("aria-haspopup", "true");
    this.button.setAttribute("aria-expanded", "false");
    this.dropdown.setAttribute("aria-hidden", "true");
  }

  syncSelectedOptions() {
    const selectedCheckboxes = this.optionCheckboxes.filter(
      (checkbox) => checkbox.checked
    );
    this.selectedOptions = selectedCheckboxes.map((checkbox) =>
      checkbox.dataset.value.replace("&", "&amp;")
    );

    this.selectedLabel =
      this.selectedOptions.length === this.optionCheckboxes.length
        ? "All Products"
        : selectedCheckboxes
            .map(
              (checkbox) =>
                checkbox.parentNode.querySelector("label").textContent
            )
            .join(", ");

    this.labelTarget.value = this.selectedLabel;

    const storeLocator = document.querySelector("store-locator");
    storeLocator.setMarkers(storeLocator.locations);
  }
}

customElements.define("store-filter", StoreFilter);
